import { User } from "../models/user";
import HomePageLoggedInView from "./HomePageLoggedInView";
import { Group1Schema } from "../models/Group1Items";

interface HomePageProps {
    loggedInUser: User | null;
    group1: Group1Schema[];
}

const HomePage = ({loggedInUser, group1}: HomePageProps) => {

    return (
        <>
            {loggedInUser
                ? <HomePageLoggedInView group1={group1}/>
                : <></>
            }
        </>
    );
}

export default HomePage;